<template>
    <div style="margin-top: -4px;">
      <div class="homePage">
        <van-row style="font-size:16px;background-color:#009CE3;line-height:48px;color:white">
            <div>
                <p class="title" style="margin:2px;font-size:20px;text-align:left;text-indent:1em;font-weight:400">{{companyName}}</p>
                <van-row>

                  <!-- <van-col span="4" style="padding-left:12px;margin-left:10px;">
                    <div @click="changeApp('wms')">-->

                      <van-col span="4" style="padding-left:12px;margin-left:10px;">
                    <div @click="changeApp('wms')">
                        <div class="wms"></div>
                        <div style="text-indent:0.2em;font-size:14px;margin-top:-10px;">WMS</div>
                      </div>
                  </van-col>
                  <van-col span="4" style="padding-left:12px">
                    <div @click="changeApp('mes')">
                      <div class="manufactor"></div>
                      <div style="text-indent:0.2em;font-size:14px;margin-top:-10px;">MES</div>
                  </div>
                  </van-col>
                  <van-col span="4" style="padding-left:12px">
                    <div>
                      <div class="crm"></div>
                      <div style="text-indent:0.2em;font-size:14px;margin-top:-10px;">CRM</div>
                  </div>
                  </van-col>
                  <van-col span="4" style="padding-left:12px">
                    <div>
                      <div class="audit"></div>
                      <div style="text-indent:0.2em;font-size:14px;margin-top:-10px;">审核</div>
                  </div>
                  </van-col>
                  <van-col span="4" style="padding-left:12px">
                    <div>
                      <div class="alarm"></div>
                      <div style="text-indent:0.2em;font-size:14px;margin-top:-10px;">预警</div>
                  </div>
                  </van-col>
                </van-row>
            </div>
        </van-row>

        <van-row>
            <van-col span="12" style="padding:12px 12px 0 24px;height:40px;">
                <div style="background-color:#6CADFF;color:white;border-radius:10px;">
                    <van-row style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{data.totalGz}}</van-row>
                    <van-row style="height:32px;line-height:24px;text-align:center;margin-top:-10px;font-size:15px;">工资总计(元)</van-row>
                </div>
            </van-col>
            <van-col span="12" style="padding:12px 24px 0 12px;height:40px;">
                <div style="background-color:#AD84FE;color:white;border-radius:10px;" @click="viewWorkListDetail(0)">
                    <van-row style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{data.totalCount}}</van-row>
                    <van-row style="height:32px;line-height:24px;text-align:center;margin-top:-10px;font-size:15px;">报工单总数</van-row>
                </div>
            </van-col>
            <van-col span="12" style="padding:12px 12px 0 24px;height:40px;margin-top:48px;">
                <div style="background-color:#75CE8C;color:white;border-radius:10px;" @click="viewWorkListDetail(1)">
                    <van-row style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{data.totalPassCount}}</van-row>
                    <van-row style="height:32px;line-height:24px;text-align:center;margin-top:-10px;font-size:15px;">良品数({{data.totalPassRate}}%)</van-row>
                </div>
            </van-col>
            <van-col span="12" style="padding:12px 24px 0 12px;height:40px;margin-top:48px;">
                <div style="background-color:#FA7E5C;color:white;border-radius:10px;" @click="viewWorkListDetail(2)">
                    <van-row style="height:54px;line-height:54px;text-align:center;font-size:20px;">{{data.totalUnpassCount}}</van-row>
                    <van-row style="height:32px;line-height:24px;text-align:center;margin-top:-10px;font-size:15px;">不良品数({{data.totalUnPassRate}}%)</van-row>
                </div>
            </van-col>
        </van-row>
      </div>

      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        @select="onSelect"
        placement="left-end"
        style="position:absolute;bottom: 60px;right:20px;"
      >
        <template #reference>
          <span style="background-color:rgb(0, 156, 227);color:white;width:48px;height:48px;display:inline-block;text-align:center;line-height:48px;border-radius:24px;font-size:15px">{{action.text}}</span>
        </template>
      </van-popover>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import Vue from 'vue';
  import { Toast, Dialog } from "vant";
  import 'xe-utils'
  import VXETable from 'vxe-table'
  import 'vxe-table/lib/style.css'
  import { Popover } from 'vant';
  import store from '../../store/index'
  import { getStatistic } from '../../api/wms/statistic/index'

  Vue.use(Popover);
  Vue.use(VXETable)

  export default {
    components: {
    },
    computed: {
      tableHeight(){
        return window.innerHeight - 360;
      }
    },
    data() {
      return {
        showPopover: false,
        // 通过 actions 属性来定义菜单选项
        actions: [{ text: '今天' }, { text: '昨天' }, { text: '本周' }, { text: '本月'}, { text: '全部'}],
        action:{ text: '今天' },
        companyName:null,
        
        data:{
          totalCount:0,
          totalGz:0.00,
          totalPassCount:0,
          totalUnpassCount:0,
          totalPassRate:'',
          totalUnPassRate:''
        }
      };
    },
    async mounted(){
      this.companyName = store.state.authorize.companyName;
      this.loadData();
    },
    methods: {
      goHome(){
        this.$router.push('/home')
      },
      sortList(){
        
      },
      onSelect(action) {
        this.action = action;
        this.loadData();
      },
      changeApp(appName){
        store.commit('app/SET_CURAPP', appName)
        setTimeout(() => {
          window.location.reload();
        }, 500); 
      },
      viewWorkListDetail(type){
        this.$router.push({
            path:'/workListDetail',
            query:{
              type:this.action.text,
              finishType:type
            }
          });
      },
      loadData(){
        Toast.loading({
          message: '数据加载中...',
          forbidClick: true,
          duration: 0 
      });


        getStatistic(this.action.text).then(res=>{
          this.data = res.data;
          this.$forceUpdate();
          Toast.clear();
        });
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  h3 {
    margin:4px;
    font-family: 'Microsoft YaHei';
    font-size: 14px;
    color:rgba(0,0,0,0.5);
  }
  
  .title {
    text-align: center;
    margin: 16px;

    font-family: cursive;
  }

  .wms {
    background: url('./1.png');
    height:32px;
    width:32px;
    background-size:cover;
  }

  .manufactor{
    background: url('./2.png');
    height:32px;
    width:32px;
    background-size:cover;
  }

  .crm{
    background: url('./3.png');
    height:32px;
    width:32px;
    background-size:cover;
  }

  .audit{
    background: url('./4.png');
    height:32px;
    width:32px;
    background-size:cover;
  }

  .alarm{
    background: url('./5.png');
    height:32px;
    width:32px;
    background-size:cover;
  }
  </style>
  